module.exports = __webpack_public_path__ + "img/award (12).156d85e6.jpg";